import { Box, Typography, Button, Stack, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { site } from 'config/site';
import { motion } from 'framer-motion';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function Hero(){
  return (
    <Box 
      component="section"
      sx={{ 
        position: 'relative',
        py: { xs: 8, md: 16 }, 
        textAlign: 'center',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>


        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        >
          <Typography 
            variant="h2" 
            component="h1" 
            sx={{ 
              fontWeight: 800, 
              mb: 3, 
              fontSize: { xs: '2.5rem', md: '4rem' }
            }}
          >
            Innovación en <span className="text-gradient">movimiento</span>
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
        >
          <Typography 
            variant="h6" 
            sx={{ 
              color: 'text.secondary', 
              mb: 6, 
              mx: 'auto',
              fontWeight: 400,
              fontSize: { xs: '1rem', md: '1.25rem' },
              maxWidth: '80%'
            }}
          >
            Asesoría en TI, soporte en sitio en CDMX y soporte remoto en todo México.
            Optimiza tu operación con decisiones tecnológicas informadas.
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.6, type: "spring" }}
        >
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center" alignItems="center">
            <Button 
              variant="contained" 
              color="primary" 
              component={Link} 
              to="/contacto"
              size="large"
              endIcon={<ArrowForwardIcon />}
              sx={{ minWidth: 200, py: 1.5, fontSize: '1.1rem' }}
            >
              Solicitar asesoría
            </Button>
            <Button 
              variant="outlined" 
              color="primary" 
              href={site.whatsapp.link} 
              target="_blank"
              size="large"
              startIcon={<WhatsAppIcon />}
              sx={{ 
                minWidth: 200, 
                py: 1.5, 
                fontSize: '1.1rem',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#F8FAFC',
                '&:hover': {
                  background: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.2)'
                }
              }}
            >
              Hablemos por WhatsApp
            </Button>
          </Stack>
        </motion.div>
      </Container>
    </Box>
  );
}